import styled from 'styled-components';

import { Button } from '@hivebrite/design-system/Button';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';

const OfflinePaymentButton = ({ href, label }) => (
  <DefaultLinkStyled href={href} data-bypass-router target="_blank">
    <ButtonStyled variant="secondary" width="100%">
      {label}
    </ButtonStyled>
  </DefaultLinkStyled>
);

export default OfflinePaymentButton;

const DefaultLinkStyled = styled(DefaultLink)`
  min-width: 0;
`;

const ButtonStyled = styled(Button)`
  width: 100%;
`;
